/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SectionAnswerDto } from './SectionAnswerDto';
import {
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoFromJSONTyped,
    SectionAnswerDtoToJSON,
    SectionAnswerDtoToJSONTyped,
} from './SectionAnswerDto';

/**
 * 
 * @export
 * @interface InspectionResultResponse
 */
export interface InspectionResultResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    formInstanceId?: string;
    /**
     * 
     */
    snapshotId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    categoryId?: string;
    /**
     * 
     */
    operatorId?: string;
    /**
     * 
     */
    completedAt?: Date;
    /**
     * 
     */
    answers?: Array<SectionAnswerDto>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the InspectionResultResponse interface.
 */
export function instanceOfInspectionResultResponse(value: object): value is InspectionResultResponse {
    return true;
}

export function InspectionResultResponseFromJSON(json: any): InspectionResultResponse {
    return InspectionResultResponseFromJSONTyped(json, false);
}

export function InspectionResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'formInstanceId': json['formInstanceId'] == null ? undefined : json['formInstanceId'],
        'snapshotId': json['snapshotId'] == null ? undefined : json['snapshotId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'operatorId': json['operatorId'] == null ? undefined : json['operatorId'],
        'completedAt': json['completedAt'] == null ? undefined : (parseDateTime(json['completedAt'])),
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(SectionAnswerDtoFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function InspectionResultResponseToJSON(json: any): InspectionResultResponse {
    return InspectionResultResponseToJSONTyped(json, false);
}

export function InspectionResultResponseToJSONTyped(value?: InspectionResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'formInstanceId': value['formInstanceId'],
        'snapshotId': value['snapshotId'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'categoryId': value['categoryId'],
        'operatorId': value['operatorId'],
        'completedAt': value['completedAt'] == null ? value['completedAt'] : serializeDateTime(value['completedAt']),
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(SectionAnswerDtoToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

